import type { AdvisorBranding } from '../types/webReport';

/**
 * Override CSS custom properties from advisor branding so the rest of the
 * report inherits per-advisor colors without each component knowing about
 * them. Falls back silently when fields are missing.
 *
 * The deck references every brand color through these vars (see
 * src/deck/theme.ts) — there are no hardcoded brand literals in components,
 * so this override repaints the whole experience.
 */
export function applyBranding(branding?: AdvisorBranding | null) {
  if (!branding) return;
  const root = document.documentElement.style;
  if (branding.primaryColor) root.setProperty('--color-accent', branding.primaryColor);
  if (branding.darkColor) root.setProperty('--color-dark', branding.darkColor);
  if (branding.creamColor) root.setProperty('--color-cream', branding.creamColor);
  if (branding.accentColor) root.setProperty('--color-accent-soft', branding.accentColor);
  // Optional extended keys (flow through /meta features.branding verbatim).
  if (branding.growthColor) root.setProperty('--color-growth', branding.growthColor);
  if (branding.cardColor) root.setProperty('--color-card', branding.cardColor);
  if (branding.displayFont) root.setProperty('--font-display', branding.displayFont);
}
